import React from "react";
import { connect } from "react-redux"
import NuevaInstanciaParametro from "./NuevaInstanciaParametro";

//Importación de actions.
import {
    obtenerInformacionPantalla,
    agregarEquivalencia,
    eliminarEquivalencia,
    actualizarEquivalencia,
    actualizarParametro,
    reiniciarEstado,
    guardarNuevaInstanciaParametro,
    finalizarSaga,
    mostrarSpinner,
    cambiarActivoInstanciaParametro,
    ocultarMostrarModalPostValidador,
    actualizarSubEquivalencia,
    setValorDefault
} from "../actions/Actions";


const mapStateToProps = (state) => {
    return {
        ...state.nuevaInstanciaParametro,
        atlas: state.atlas
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        obtenerInformacionPantalla: (currentScope) => {
            dispatch(obtenerInformacionPantalla(currentScope));
        },
        agregarEquivalencia: () => {
            dispatch(agregarEquivalencia());
        },
        eliminarEquivalencia: (id) => {
            dispatch(eliminarEquivalencia(id));
        },
        actualizarEquivalencia: (idEquivalenciaInstancia, idEquivalencia, valorEquivalencia) => {
            dispatch(actualizarEquivalencia(idEquivalenciaInstancia, idEquivalencia, valorEquivalencia));
        },
        actualizarParametro: (codigo, valor) => {
            dispatch(actualizarParametro(codigo, valor));
        },
        reiniciarEstado: () => {
            dispatch(reiniciarEstado());
        },
        guardarNuevaInstanciaParametro: () => {
            dispatch(guardarNuevaInstanciaParametro());
        },
        finalizarSaga: () => {
            dispatch(finalizarSaga());
        },
        mostrarSpinner: () => {
            dispatch(mostrarSpinner());
        },
        cambiarActivoInstanciaParametro: () => {
            dispatch(cambiarActivoInstanciaParametro());
        },
        ocultarMostrarModalPostValidador: () => {
            dispatch(ocultarMostrarModalPostValidador());
        },
        actualizarSubEquivalencia: (idEquivalenciaInstancia, idSubEquivalencia, codigoSubequivalencia) => {
            dispatch(actualizarSubEquivalencia(idEquivalenciaInstancia, idSubEquivalencia, codigoSubequivalencia));
        },
        setValorDefault: (valorDefault, idEquivalenciaInstancia) => {
            dispatch(setValorDefault(valorDefault, idEquivalenciaInstancia));
        }
    }
}

const NuevaInstanciaParametroContainer = connect(mapStateToProps, mapDispatchToProps)(NuevaInstanciaParametro);

export default NuevaInstanciaParametroContainer;
